import React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";
import { createRoot } from "react-dom/client";

declare global {
  interface Window {
    renderCats: any;
    unmountCats: any;
  }
}

window.renderCats = (containerId: string) => {
  ReactDOM.render(<App />, document.getElementById(containerId));
};

window.unmountCats = (containerId: string) => {
  const element = document.getElementById(containerId);
  if (element) {
    ReactDOM.unmountComponentAtNode(element);
  }
};

if (!document.getElementById("Cats-container")) {
  const rootElement = document.getElementById("root");
  const root = createRoot(rootElement!);

  root.render(<App />);
}
